<app-header></app-header>
<div class="dashboard-content">

</div>
